import React,{useState,useEffect} from "react";
import { CSVLink } from "react-csv";
import {
  Card,
  CardText,
  CardTitle,
  Cell,
  DataTable,
  Grid,
  SelectField,
  TableBody,
  TableColumn,
  TableRow,
  TextField,
  Button
} from "react-md";
import crossIcon from '../../images/png/crossIcon.png';
import { NotificationManager } from "react-notifications";
import "../../css/mediaCss.css";
import MathParserUtil from "../../lib/math-parser";
import { VariableTypes, VariableTypesAnswer } from "../../lib/types";
import styles from "../../css/styles.css";
import Toggle from "react-toggle";
import { SelectionControlGroup } from "react-md";
import TextEditor  from "../../component/TextEditor"
import {  EditorState,ContentState } from 'draft-js';
import Editor from 'draft-js-plugins-editor';
import { evaluateOptions,QueryOptions } from "../../../src/component/vectors/commonHelpers"; 
import { confirmAlert } from 'react-confirm-alert';
import MathJax from '../../component/react-mathjax-preview';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField as MTextField } from "@mui/material";
import { FaEdit, FaTrashAlt } from "react-icons/fa";

export const createEmptyDisplayOption = () => {
  return {
    type: "FLOAT",
    decimalLimit: "",
    precision: "",
    sigFig: "3",
    isDefaultValue:true
  };
};

/*
const showDecimalLimit = function(dataType){
     
    console.log('showDecimalLimit',dataType);
    if(dataType){
        
        switch(dataType){
            case VariableTypes.SCIENTIFIC_NOTATION:
                return true;
            default:
                return false;
    
        }
    }
    return true;
    
}*/
export class AnswerOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options,
      fileContents: "",
      isCaseSensitive: false,
    };
  }

  onAnswerTypeChange = (value) => {
    let options = this.props.options;
    options.type = value;
    switch (value) {
      case VariableTypes.FLOAT:
        options.sigFig = "3";
        break;
      case VariableTypes.SCIENTIFIC_NOTATION:
        options.precision = "0";
        options.decimalLimit = "1";
        break;
      default:
        break;
    }
    if (this.props.onChange) this.props.onChange(options);

    this.setState({
      options,
    });
  };

  componentDidMount() {
    let options = this.props.options;

    if ( options.isDefaultValue && 
        this.props.answerVariable !== undefined && this.props.questionVectorTableMap !== undefined 
        && this.props.questionVectorTableMap?.get(this.props.answerVariable) ) {
        options.sigFig =  this.props.questionVectorTableMap.get(this.props.answerVariable)?.sigFig
        if (this.props.onChange) this.props.onChange(options);
      }
    this.setState({
      options,
    });
  }
  componentWillReceiveProps(newprops) {
    const { options } = newprops;
    console.debug("newprops" ,newprops)
    if (options.type === "") {
      options.type = VariableTypes.FLOAT;
      options.sigFig = "3";
    }
    this.setState({
      options,
    });

    if (newprops.onChange) newprops.onChange(options);
  }
  onDecimalLimitChange = (value) => {
    if (value.startsWith("-") || value.search("/") !== -1) {
      NotificationManager.error(
        "Error: Invalid format. Use only numbers > 0. Don’t use negative numbers or fractions."
      );
    } else {
      let options = this.props.options;
      options.decimalLimit = value;
      if (this.props.onChange) this.props.onChange(options);

      this.setState({
        options,
      });
    }
  };

  onPrecisionChange = (value) => {
    if (value.search("-") !== -1 || value.search("/") !== -1) {
      NotificationManager.error(
        "Error: Invalid format. Use only numbers >0. Don’t use negative numbers or fractions."
      );
    } else {
      let options = this.props.options;
      options.precision = value;
      if (this.props.onChange) this.props.onChange(options);

      this.setState({
        options,
      });
    }
  };

  onSigFigChange = (value) => {
    if (value.search("-") !== -1 || value.search("/") !== -1) {
      NotificationManager.error(
        "Error: Invalid format. Use only numbers >0. Don’t use negative numbers or fractions."
      );
    } else {
      let options = this.props.options;
      options.sigFig = value;
      options.isDefaultValue =false
      if (this.props.onChange) this.props.onChange(options);

      this.setState({
        options,
      });
    }
  };

  render() {
    if (!this.props.options) {
      return null;
    }

    return (
      <Card className={this.props.className}>
        <CardTitle title="Answer Options" />
        <CardText>
          <DataTable plain responsive={false}>
            <TableBody>
              <TableRow>
                <TableColumn>
                  <SelectField
                    id="answer-type"
                    label="Answer Type"
                    placeholder="Answer Type"
                    menuItems={Object.keys(VariableTypesAnswer)}
                    value={
                      this.state.options.type === ""
                        ? VariableTypes.FLOAT
                        : this.state.options.type
                    }
                    onChange={this.onAnswerTypeChange}
                    helpText="Select a format type INT, FLOAT etc"
                  />
                </TableColumn>
                {this.props.options.type === VariableTypes.FLOAT ? (
                  <TableColumn>
                    <TextField
                      label="Significant Figures"
                      onChange={this.onSigFigChange}
                      value={
                        this.state.options.isDefaultValue && 
                        this.props.answerVariable !== undefined && this.props.questionVectorTableMap !== undefined && this.props.questionVectorTableMap?.get(this.props.answerVariable) 
                          ? this.props.questionVectorTableMap.get(this.props.answerVariable)?.sigFig
                          : this.state.options.sigFig || ""
                      }
                      type="number"
                      helpText="Number of Significant Figures, the rest will be rounded"
                    />
                  </TableColumn>
                ) : this.props.options.type ===
                  VariableTypes.SCIENTIFIC_NOTATION ? (
                  <TableColumn>
                    <TextField
                      id="decimal-limit"
                      label="Decimal Limit"
                      placeholder="Decimal Limit"
                      value={this.state.options.decimalLimit || ""}
                      onChange={this.onDecimalLimitChange}
                      type="number"
                      helpText="Number of Digits after Decimal point, the rest will be rounded"
                    />
                  </TableColumn>
                ) : this.props.options.type ===
                  VariableTypes.SCIENTIFIC_NOTATION ? (
                  <TableColumn>
                    <TextField
                      label="Precision"
                      onChange={this.onPrecisionChange}
                      value={this.state.options.precision || ""}
                      placeholder="Precision"
                      type="number"
                      helpText="Number of Digits after Decimal point, the rest will be rounded"
                    />
                  </TableColumn>
                ) : null}
              </TableRow>
            </TableBody>
          </DataTable>
        </CardText>
      </Card>
    );
  }
}

export const TextAnswerFormula = (props) => {
  let classNameString = "md-block-centered";
  const [formulaAdd,setFormulaAdd] = useState(props?.answer_formula?.addFormulaSwitch)
  const [editorPrefixState, setEditorPrefixState] = useState(() => {
    if (props.answer_formula && props.answer_formula.formula && props.answer_formula?.formulaPrefix) {
      const contentState = ContentState.createFromText(props.answer_formula?.formulaPrefix);
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  });
  const [editorSuffixState, setEditorSuffixState] = useState(() => {
    if (props.answer_formula && props.answer_formula.formula && props.answer_formula?.formulaSuffix) {
      const contentState = ContentState.createFromText(props.answer_formula?.formulaSuffix);
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  });

  if (props.className)
    classNameString = classNameString + " " + props.className;

  let help_text = { 
    formula: "{{[\\vec{A}_x]+[\\vec{A}_y]}}",
  }
  const onEditorPrefixChange = (state) => {
    setEditorPrefixState(state);
    let enteredString = state.getCurrentContent().getPlainText();
    onAnswerFormulaPrefixChange(enteredString);
  };
  const onEditorSuffixChange = (state) => {
    setEditorSuffixState(state);
    let enteredString = state.getCurrentContent().getPlainText();
    onAnswerFormulaSuffixChange(enteredString);
  };
  const onAnswerTextChange = (value) => {
    let ansOptions = { ...props.answer_formula };
    ansOptions.formula = value;
    var formulaMap;

    formulaMap = MathParserUtil.getAnswerFormulasFromText(
      value,
      ansOptions.formulaMap
    );
    console.log(formulaMap);
    ansOptions.formulaMap = formulaMap;
    props.onChange(ansOptions);
  };
  const onAnswerFormulaOneOptionChange = (value) => {
    let ansOptions = { ...props.answer_formula };
    ansOptions.formulaOneEvaluateOption = value;
    props.onChange(ansOptions);
  };

  const onAnswerFormulaSigFigValueChange = (value) => {
    let ansOptions = { ...props.answer_formula };
    ansOptions.formulaSigFigOptionValue = parseInt(value);
    props.onChange(ansOptions);
  };

  const onAnswerFormulaSigFigOptionChange = (value) => {
    let ansOptions = { ...props.answer_formula };
    ansOptions.formulaSigFigOption = value ? 1 : 0;
    props.onChange(ansOptions);
  };

  const onAnswerFormulaPrefixChange = (value) => {
    let ansOptions = { ...props.answer_formula };
    ansOptions.formulaPrefix = value;
    props.onChange(ansOptions);
  };
  const onAnswerFormulaSuffixChange = (value) => {
    let ansOptions = { ...props.answer_formula };
    ansOptions.formulaSuffix = value;
    props.onChange(ansOptions);
  };

  const onAddFormulaChange = (value) =>{
    let ansOptions = { ...props.answer_formula };
    ansOptions.addFormulaSwitch = value;
    setFormulaAdd(value)
    props.onChange(ansOptions);
  }
  const onAnswerFormulaQueryOptionChange = (value) => {
    let ansOptions = { ...props.answer_formula };
    ansOptions.formulaqueryOption = value;
    props.onChange(ansOptions);
  };
  const onAnswerFormulaTwoOptionChange = (value) => {
    let ansOptions = { ...props.answer_formula };
    ansOptions.formulaTwoEvaluateOption = value;
    props.onChange(ansOptions);
  };
  const onAnswerTwoTextChange = (value) => {
    let ansOptions = { ...props.answer_formula };
    ansOptions.formulaTwo = value;

    props.onChange(ansOptions);
  };

  const onValidationMode = (value, obj) => {
    let answerFormula = { ...props.answer_formula };
    let formulaMapTemp = answerFormula.formulaMap;
    formulaMapTemp.set(obj.text, { ...obj, validationMode: value });
    answerFormula.formulaMap = formulaMapTemp;
    props.onChange(answerFormula);
  };

  const accuracyRange = (value, type, obj) => {
    let answerFormula = { ...props.answer_formula };
    let formulaMapTemp = answerFormula.formulaMap;
    obj[type] = value;
    formulaMapTemp.set(obj.text, { ...obj });
    answerFormula.formulaMap = formulaMapTemp;
    props.onChange(answerFormula);
  };

  const mapListValue = (value, listName, obj) => {
    let answerFormula = { ...props.answer_formula };
    let formulaMapTemp = answerFormula.formulaMap;
    if (!obj["listValues"]) {
      obj["listValues"] = {};
    }
    obj["listValues"][listName] = value;
    formulaMapTemp.set(obj.text, { ...obj });
    answerFormula.formulaMap = formulaMapTemp;
    props.onChange(answerFormula);
  };
  const generateRPAnswer = (formulaItem) => {
    if(formulaItem != "" && props?.variablesMap) {
      let formulaText = formulaItem.text
      let correctAnswer = MathParserUtil.computeAnswer(formulaText,props?.variablesMap)
      let answer_formula = props?.answer_formula
      if(answer_formula?.formulaSigFigOption === 1 && answer_formula?.formulaSigFigOptionValue){
        return Number(correctAnswer).toPrecision(answer_formula?.formulaSigFigOptionValue)
      }
      return correctAnswer
    }
    return ""
  }
  const generateRPAnswerEnotation = (formulaItem) => {
    if(formulaItem != "" && props?.variablesMap) {
      let formulaText = formulaItem.text
      let correctAnswer = MathParserUtil.computeAnswer(formulaText,props?.variablesMap)
      let answer_formula = props?.answer_formula
      if(answer_formula?.formulaSigFigOption === 1 && answer_formula?.formulaSigFigOptionValue){
        return  Number(generateRPAnswer(formulaItem)).toExponential(answer_formula?.formulaSigFigOptionValue-1)
      }
      return correctAnswer
    }
    return ""
  }
  const generateScifiRPAnswer = (formulaItem) => {
    if(formulaItem != "" && props?.variablesMap) {
      let formulaText = formulaItem.text
      let correctAnswer = MathParserUtil.computeAnswer(formulaText,props?.variablesMap)
      let sciText;
      let answer_formula = props?.answer_formula

      if(correctAnswer && Number(correctAnswer) ){
        let expValue;
        if(answer_formula?.formulaSigFigOption === 1 && answer_formula?.formulaSigFigOptionValue){
          expValue = Number(correctAnswer).toExponential(answer_formula?.formulaSigFigOptionValue-1);
        }else if(formulaItem?.validationMode === "precision"){
          const significantDigit =  parseInt(formulaItem?.answerPrecision, 10) || 1;
          expValue = correctAnswer.toExponential(significantDigit-1);
        }else{
          expValue = correctAnswer.toExponential(2);
        } 
        const sciValue = expValue.toString().replace('e','\\times 10^').replace('10^+','10^');
        const powerExp = sciValue.substr(sciValue.indexOf('10^'), sciValue.length);
        const powerDigit = sciValue.substr(sciValue.indexOf('10^')+3, sciValue.length);
        const replacedText = `10^{${powerDigit}}`;
        sciText = sciValue.replace(powerExp,replacedText);
      }
      return sciText;
    }
    return ""
  }
  const generateFracRPAnswer = (formulaItem) => {
    if(formulaItem != "" && props?.variablesMap) {
      let formulaText = formulaItem.text
      let correctAnswer = MathParserUtil.computeAnswer(formulaText,props?.variablesMap)
      let fractionValue;
      if(correctAnswer && Number(correctAnswer) ){
        fractionValue = MathParserUtil.getFractionValue(correctAnswer);
      }
      return fractionValue;
    }
    return ""
  }

  const validationModeRender = (props) => {
    return  <div>
      {props.answer_formula && props.answer_formula.formulaMap 
        ? Array.from(props.answer_formula.formulaMap.values()).map(
            (formulaItem) => {
              return (
                <tr key={`key-${formulaItem.text}`}>
                  <td style={{ minWidth: "100px" }}>
                    <Grid>
                      <Cell>
                        <div style={{marginTop:"15%",display:"flex",alignItems:"center"}}>
                          <div>
                          {formulaItem.text} 
                          {
                              props?.questionType === 1 ?
                              "=" : ""
                            }
                         
                          </div>
                          <div>

                            {  
                              (props?.answerFormat === 1  ||  props?.answerFormat ===  5) && props?.questionType === 1? 
                              generateRPAnswer(formulaItem) :
                              props?.answerFormat === 2  && props?.questionType === 1?
                          
                              <div style={{display:"flex",alignItems:"center",display:"inline-block"}}>
                                  <MathJax math={`$$ ${generateScifiRPAnswer(formulaItem)   } $$`} className="rp-answer-math-jax" />
                              </div> :

                              props?.answerFormat === 3 ? (
                                <div style={{ display: "inline-block", alignItems: "center" }}>
                                    {(() => {
                                      const fraction = generateFracRPAnswer(formulaItem); // Declared inside the div
                                  
                                      return (
                                        <>
                                          {fraction?.s === -1 ? (
                                            <span style={{ fontSize: "20px", padding: "0px" }}>&#8212;</span>
                                          ) : null}
                                                                      
                                          {fraction && (
                                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "0 5px" }}>
                                                <div style={{ fontSize: "20px", }}>{fraction.n}</div>
                                                <div style={{ width: "100%", height: "2px", backgroundColor: "black", margin: "2px 0" }}></div>
                                                <div style={{ fontSize: "20px" }}>{fraction.d}</div>
                                              </div>
                                            )}

                                        </>
                                      );
                                    })()}
                                  </div>
                                )

                                : 
                                props?.answerFormat === 6 && props?.questionType === 1?
                                generateRPAnswerEnotation(formulaItem): ""
                                
                                }
                          </div>
                        </div>
                        </Cell>
                      <Cell>
                        <SelectField
                          id={`id-validation-mode`}
                          label="Answer Validation Mode"
                          placeholder="Choose a correct answer validation mode"
                          menuItems={[
                            ...(props.variablesMap?.get(
                              MathParserUtil.removeBrackets(
                                formulaItem.text
                              )
                            ) &&
                            props.variablesMap?.get(
                              MathParserUtil.removeBrackets(
                                formulaItem.text
                              )
                            ).type === VariableTypes.LIST
                              ? [
                                  {
                                    label: "List",
                                    value: "list",
                                  },
                                ]
                              : []),
                            {
                              label: "Error percentage range",
                              value: "errorPercentage",
                            },
                            {
                              label: "Error absolute range",
                              value: "valueRange",
                            },
                            {
                              label: "Answer precision (Sig Figs)",
                              value: "precision",
                            },
                          ]}
                          helpText="Please choose how the correct answer should be validated"
                          onChange={(value) =>
                            onValidationMode(value, formulaItem)
                          }
                          value={
                            formulaItem && formulaItem.validationMode
                              ? formulaItem.validationMode
                              : ""
                          }
                        />
                      </Cell>
    
                      {formulaItem.validationMode ===
                      "errorPercentage" ? (
                        <Cell>
                          <TextField
                            fullWidth
                            id="randomised-formula-option"
                            label="Error percentage range"
                            value={
                              formulaItem && formulaItem.accuracyRange
                                ? formulaItem.accuracyRange
                                : ""
                            }
                            onChange={(value) =>
                              accuracyRange(
                                value,
                                "accuracyRange",
                                formulaItem
                              )
                            }
                            helpText="Error percentage range”: In terms of percent (with 1% as default value) Add this hover “Example: “15” means +/- 15%, “0.03” means +/- 0.03%"
                          />
                        </Cell>
                      ) : formulaItem.validationMode === "valueRange" ? (
                        <Cell>
                          <TextField
                            fullWidth
                            id="randomised-formula-low-value"
                            label="Error absolute range"
                            value={
                              formulaItem && formulaItem.absAccuracyValue
                                ? formulaItem.absAccuracyValue
                                : ""
                            }
                            onChange={(value) =>
                              accuracyRange(
                                value,
                                "absAccuracyValue",
                                formulaItem
                              )
                            }
                            helpText="Example: “15” means +/- 15,  “0.02” means +/- 0.02."
                          />
                        </Cell>
                      ) : formulaItem.validationMode === "precision" ? (
                        <Cell>
                          <TextField
                            fullWidth
                            id="randomised-formula-precision"
                            label="Answer precision (Sig Figs)"
                            value={
                              formulaItem && formulaItem.answerPrecision
                                ? formulaItem.answerPrecision
                                : ""
                            }
                            onChange={(value) =>
                              accuracyRange(
                                value,
                                "answerPrecision",
                                formulaItem
                              )
                            }
                            helpText="Student answers with higher sig figs than specified here will be rounded. The answer precision (i.e., significant figures), must be consistent with the sig figs of input random parameters. Example: if the correct answer is 1.200 with a given answer precision 4, 1.199 is marked incorrect, but 1.1999 is marked correct because it is first rounded to 4 sig figs = 1.200"
                          />
                        </Cell>
                      ) : formulaItem.validationMode === "list" ? (
                        <Cell size={12}>
                          <Grid>
                            {props.answerFormat === 4 ? (
                              <Cell size={2}>
                                <label
                                  htmlFor="caseSensitive"
                                  style={styles.randamizeOrderLable}
                                >
                                  <b>Case Sensitive </b>
                                </label>
    
                                <div>
                                  <Toggle
                                    id="caseSensitive"
                                    checked={props.caseSensitive}
                                    icons={false}
                                    width={230}
                                    onChange={props.changeCaseSensitive}
                                  />
                                </div>
                              </Cell>
                            ) : (
                              ""
                            )}
                            {props.answerFormat === 4 ? (
                              <Cell size={4}>
                                <SelectionControlGroup
                                  type="radio"
                                  className="answer-display-style-radio"
                                  label="Answer Validation type"
                                  value={props.selected.toString()}
                                  controls={[
                                    {
                                      label:
                                        "All answers should be correct",
                                      value: "1",
                                    },
                                    {
                                      label:
                                        "Any one of the answers could be correct",
                                      value: "2",
                                    },
                                  ]}
                                  onChange={
                                    props.changeShouldAnswerAllorAny
                                  }
                                />
                              </Cell>
                            ) : (
                              ""
                            )}
                          </Grid>
                          <table
                            style={{
                              borderSpacing: "15px",
                              width: "100%",
                            }}
                          >
                            <tbody>
                              {props.variablesMap
                                ?.get(
                                  MathParserUtil.removeBrackets(
                                    formulaItem.text
                                  )
                                )
                                .listValues.split(",")
                                .map((listValueArg, index) => {
                                  const listValue = listValueArg.trim();
                                  return (
                                    <tr key={`list-value-${index}`}>
                                      <td>{listValue}</td>
                                      <td>
                                        <TextField
                                          fullWidth
                                          id={`list-value-${index}`}
                                          label={`Enter the correct answer for ${listValue}`}
                                          onChange={(value) =>
                                            mapListValue(
                                              value,
                                              listValue,
                                              formulaItem
                                            )
                                          }
                                          value={
                                            formulaItem &&
                                            formulaItem.listValues &&
                                            formulaItem.listValues[
                                              listValue
                                            ]
                                              ? formulaItem.listValues[
                                                  listValue
                                                ]
                                              : ""
                                          }
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </Cell>
                      ) : null}
                    </Grid>
                  </td>
                </tr>
              );
            }
          )
        : null}
        
    </div>
  }
  
  return (
    <Card className={classNameString}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>

      <CardTitle
        title="Correct Answer Formula"
        subtitle="Enter correct answer formula and options"
      />
      {
        props?.answerFormat === 1 || props?.answerFormat === 2 || props?.answerFormat === 5 ||props?.answerFormat === 6 ?

      <div style={{marginRight:"70px",marginTop:"20px"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>

            <div style={{marginRight:"5px"}}>
                <label
                  htmlFor="sigfig"
                >
                  <b>Significant Fig</b>
                </label>
            </div>
              <Toggle
                  id="sigfig"
                  // ref="sigfig"
                  // disabled={this.state.questionType === 0 && this.state.defaultAnswerType===2 ? true : false}
                  checked={
                    props.answer_formula.formulaSigFigOption
                  }
                  icons={false}
                  width={230}
                  onChange={(event) => {
                    onAnswerFormulaSigFigOptionChange( event.target.checked);
                  }}
                />
        </div>
        {
           props.answer_formula.formulaSigFigOption ?

            <div>
              
                <TextField
                    className="textFieldClass"
                    type="number"
                    rows={1}
                    value={ props.answer_formula.formulaSigFigOptionValue || 0}
                    label="SigFig Number"
                    onChange={(value) => onAnswerFormulaSigFigValueChange(value)}
                  />
            </div> : ""
        }
      </div> :""
      }
      </div>
      <CardText>
        <table style={{ width: "103%" }}>
          {props?.questionType === 3 && props?.defaultAnswerType === 3 && (props?.answerFormat === 1 || props?.answerFormat === 2) ?
          <Cell size={12}>
              <Grid style={{border:"1px solid #9F9F9F",borderRadius:"5px" ,padding:"0px"}}>

              <Cell size={formulaAdd ? 2:3} style={{padding:"0px",margin:"0px",marginRight:"8px",marginTop:"2%"}}>   
                <div style={{display:"flex",height:"100%"}}>
                    
                    <div  style={{ display: "flex",textWrap:"wrap",fontSize:"12px",paddingRight:"5px"}}>
                    <label
                        className="vectors-toggle-label"
                      > 
                        <div style={{marginTop: "33%",fontSize:"12px",marginLeft:"15px"}}>
                         Answer Formula
                        </div>
                      </label>
                      </div>   
                    <div style={{paddingLeft:"10px"}}>

                      <SelectField
                          helpText="Select"
                          defaultValue={0}
                          style={{marginTop: "33%"}}
                          onChange={(value) => {
                            onAnswerFormulaOneOptionChange(value)
                          }}

                          menuItems={evaluateOptions}
                          value={ props.answer_formula ? props.answer_formula?.formulaOneEvaluateOption : ""}
                        />
                    </div>
                </div>

              </Cell>
              <Cell size={formulaAdd ? 1:2} >
                    <div>
                      <div style={{marginTop:"6px",color:"rgba(0, 0, 0, 0.54)",fontSize:"17px",fontWeight:"400"}}>
                          Text Before
                      </div>
                      <div style={{borderBottom:"1px solid rgba(0, 0, 0, 0.54)",marginTop:"10px"}}>
                        <Editor
                          editorState={editorPrefixState}
                          onChange={onEditorPrefixChange}
                          key='editorFormulaPrefixKey'
                        />
                      </div>
                    </div>
              </Cell>
              <Cell size={formulaAdd ? 3 : 3}>    
                  <TextField
                    className="textFieldClass"
                    rows={1}
                    value={ props.answer_formula ? props.answer_formula.formula : ""}
                    label="Formula 1"
                    onChange={(value) => onAnswerTextChange(value)}
                    helpText= {<div className="helpTextVector">
                                  Use  _x and _y  after the variable name eg: 
                                <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                    onClick={() => {navigator.clipboard.writeText(help_text.formula)}} >
                                  {help_text.formula}
                                  </Button> 
                              </div>
                              } 
                  />
                </Cell>
                <Cell size={formulaAdd ? 1:2} style={{borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>
                    <div>
                      <div style={{marginTop:"6px",color:"rgba(0, 0, 0, 0.54)",fontSize:"17px",fontWeight:"400"}}>
                          Text After
                      </div>
                      <div style={{borderBottom:"1px solid rgba(0, 0, 0, 0.54)",marginTop:"10px"}}>
                        <Editor
                          editorState={editorSuffixState}
                          onChange={onEditorSuffixChange}
                          key='editorFormulaSuffixxKey'
                        />
                      </div>
                    </div>
              </Cell>
                {!formulaAdd ? 
                              <Cell size={2} style={{margin:"0px"}}>
                                      <Button 
                                      style={{ width:formulaAdd ? "65px" :"100px",marginLeft:formulaAdd? "5px":"20%",marginTop:"5%",background:"#868E92",height:"80%",borderRadius:"5px",color:"white"}} 
                                      flat 
                                      onClick={()=> onAddFormulaChange(!formulaAdd)}
                                      >
                                        
                                      Add
                                      another
                                      Formula
                                      </Button>
                              </Cell> : 
                              
                              
                              <React.Fragment>

                              <Cell size={1} style={{marginLeft:"10px",marginRight:"20px"}}>   
                                <SelectField
                                    helpText="Select"
                                    className="textFieldClass"
                                    onChange={(value) => {
                                      onAnswerFormulaQueryOptionChange(value)
                                    }}
                                    style={{marginTop:"25%",paddingRight:"10px"}}
                                    menuItems={QueryOptions}
                                    value={ props.answer_formula ? props.answer_formula?.formulaqueryOption : ""}
                                    defaultValue={0}
                                  />
                            </Cell>
                                <Cell size={1} style={{borderLeft:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px"}}>   

                                    <SelectField
                                        helpText="Select"
                                        style={{marginTop:"35%",marginLeft:"10px"}}
                                        onChange={(value) => {
                                          onAnswerFormulaTwoOptionChange(value)
                                        }}
                                        defaultValue={0}
                                        menuItems={evaluateOptions}
                                        value={props.answer_formula ? props.answer_formula?.formulaTwoEvaluateOption:""}
                                      />
                                </Cell>
                            <Cell size={2} style={{marginLeft:"30px",width: "19%"}}>    
                              <div style={{display:"flex"}}>
                                <div>

                                  <TextField
                                    className="textFieldClass"
                                    rows={1}
                                    value={ props.answer_formula ? props.answer_formula.formulaTwo : ""}
                                    label="Formula 2"
                                    onChange={(value) => onAnswerTwoTextChange(value)}
                                    helpText= {<div className="helpTextVector">
                                      Use  _x and _y  after the variable name eg: 
                                    <Button className="helpTextVectorButton" tooltipLabel="copy"  
                                        onClick={() => {navigator.clipboard.writeText(help_text.formula)}} >
                                      {help_text.formula}
                                      </Button> 
                                  </div>
                                  } 
                                  />
                                </div>
                              <div>

                                  <Button  
                                        style={{marginTop:"132%"}}
                                        onClick={()=> onAddFormulaChange(!formulaAdd)}
                                        >
                                        <img
                                            src={crossIcon}
                                            alt="Delete"
                                            
                                          />
                                        </Button>
                              </div>
                              </div>
                              </Cell>
                            
                              </React.Fragment>
                      }
                                           
              </Grid>

              <Grid>
                { !formulaAdd && props.answer_formula?.formulaOneEvaluateOption === 0  ? validationModeRender(props) : ""}
              </Grid>

          </Cell>
          :
          <tbody>
            <tr className="rp-text-box-row">
                <td colSpan={4}>
                  <div style={{
                    display:"flex",
                    justifyContent:"flex-start",
                    alignItems:'center',
                    gap:'1rem'
                  }}>
                    <div style={{width:'200px'}}>
                      <div style={{ marginTop: "6px", color: "rgba(0, 0, 0, 0.54)", fontSize: "17px", fontWeight: "400" }}>
                        Text Before
                      </div>
                      <div style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.54)", marginTop: "10px" }}>
                        <Editor
                          editorState={editorPrefixState}
                          onChange={onEditorPrefixChange}
                          key='editorFormulaPrefixKey'
                        />
                      </div>
                    </div>
                    <TextField
                      style={{
                        width:'450px'
                      }}
                      id="randomised-formula-text"
                      label="Answer Formula Text"
                      placeholder="Answer Formula Text"
                      value={
                        props.answer_formula ? props.answer_formula.formula : ""
                      }
                      onChange={onAnswerTextChange}
                    />
                    <div style={{width:'200px'}}>
                      <div style={{ marginTop: "6px", color: "rgba(0, 0, 0, 0.54)", fontSize: "17px", fontWeight: "400" }}>
                        Text After
                      </div>
                      <div style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.54)", marginTop: "10px" }}>
                        <Editor
                          editorState={editorSuffixState}
                          onChange={onEditorSuffixChange}
                          key='editorFormulaPrefixKey'
                        />
                      </div>
                    </div>
                  </div>
                </td>
            </tr>
             {validationModeRender(props)}

            <tr>
              <td colSpan={3} className="rp-text-help-column">
                <AnswerHelp answerType={props.questionType === 3 && props.answerType === 3 ? 50: 0}></AnswerHelp>
              </td>
            </tr>
          </tbody>
          }
        </table>
        <br></br>
      </CardText>
    </Card>
  );
};

const VariablesTable = (props) => {

  const [variableName, setVariableName] = useState("");
  const [showVariableNameDialog, setShowVariableNameDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editingVarObj , setEditingVarObj] = useState(null);

  // if (!props.data) {
  //   return null;
  // }
  
  const onVariableDeleteConfirm =(variableObj) =>   {
      confirmAlert({
        title: 'Do you really want to delete this variable?',
        message: 'Press Confirm to submit',
  
        cancelLabel: 'Confirm',
        confirmLabel: 'Cancel',
        onCancel: () => {
          props.onDeleteVariable(variableObj);
        }
      });
  }

  const handleVariabelEditActionClick = (variableObj) => {
    console.debug("variableObj>>???", variableObj)
    let name = variableObj.name;
    name = name.replace(/[\[\]]/g, "");
    setVariableName(name);
    setShowVariableNameDialog(true);
    setEditMode(true);
    setEditingVarObj(variableObj);
  }
  
  let classNameString = "md-block-centered";
  if (props.className)
    classNameString = classNameString + " " + props.className;

  return (
    <Card className={classNameString} style={{ marginLeft: "0px" }}>
      {/* RP variable name dialog */}
      <Dialog open={showVariableNameDialog} maxWidth="xs" fullWidth>
          <DialogTitle>
            Variable name
          </DialogTitle>
          <DialogContent>
            <div style={{marginBottom:'6px'}}>
              <MTextField 
                placeholder="Enter variable name"
                fullWidth
                value={variableName}
                onChange={event => {
                  setVariableName(event.target.value);
                }}
              />
            </div>
            <small style={{color:"gray"}}>
              <ul style={{ margin: 0, paddingLeft: '16px' }}>
                <li>Use only letters (A–Z or a–z)</li>
                <li>No spaces at the beginning or end</li>
                <li>Do not use spaces between words</li>
                <li>Use underscore (_) to separate words if needed</li>
              </ul>
              <div style={{ marginTop: '6px' }}>
                <strong>Examples:</strong><br />
                ✓ valid_name<br />
                ✓ totalScore
              </div>
            </small>
          </DialogContent>
          <DialogActions>
            <Button primary flat  onClick={() => {
                  setEditMode(false);
                  setEditingVarObj(null);
                  setShowVariableNameDialog(false);
                }
              }>
              Cancel
            </Button>
            <Button primary raised 
              onClick={() => {
                  const name = variableName.trim();

                    // 1. Empty check
                    if (!name) {
                      NotificationManager.error("Variable name is required", "", 3000);
                      return;
                    }

                    // 2. No leading/trailing spaces
                    if (name !== variableName) {
                      NotificationManager.error("No leading or trailing spaces allowed", "", 3000);
                      return;
                    }

                    // 3. Only letters + underscore
                    if (!/^[A-Za-z_]+$/.test(name)) {
                      NotificationManager.error(
                        "Use only letters and underscores (_). No spaces or numbers.",
                        "",
                        3000
                      );
                      return;
                    }

                    // 4. Duplicate check (ignore current when editing)
                    const newKey = `[${name}]`;

                    let variableKeysArr = [];
                    if (props.data && props.data.keys) {
                      variableKeysArr = Array.from(props.data.keys());
                    }

                    const currentKey = editMode && editingVarObj ? editingVarObj.name : null;

                    const isDuplicate = variableKeysArr.some(
                      key => key === newKey && key !== currentKey
                    );

                    if (isDuplicate) {
                      NotificationManager.error(
                        "Variable name already exists. Please give a different name",
                        "",
                        3000
                      );
                      return;
                    }

                    // 5. Proceed
                    if (editMode) {
                      props.onEditVariable(name, editingVarObj);
                      setEditMode(false);
                      setEditingVarObj(null);
                    } else {
                      props.onAddVariable(name);
                    }

                    setShowVariableNameDialog(false);
                  }}
            >
              {editMode ? "Edit" : "Add"}
            </Button>
          </DialogActions>
      </Dialog>
      <CardTitle
        title="Variables Table"
        subtitle="Edit variables used in the Question Text"
        className="variable-table-card-title"
      />
      <CardText>
        <DataTable plain responsive={false}>
          <TableBody style={{ marginLeft: "0px" }}>
            {props.data && props.data.values() && Array.from(props.data.values()).map((variableObj, i) => {
              return (
              <TableRow key={i} style={{ marginLeft: "0px" }}>
                <TableColumn>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                      <TextField
                        style={{ width: '100px' }}
                        className="textFieldClass"
                        disabled
                        value={variableObj.name.replace(/^\[|\]$/g, "")}
                        label="Name"
                        id={`text-field-${i}`}
                        size="small"
                      />

                      <IconButton
                        aria-label="edit"
                        size="small"
                        style={{
                          marginTop:'6px',
                        }}
                        onClick={() => handleVariabelEditActionClick(variableObj)}
                      >
                        <FaEdit style={{ color: '#3d5e9c' }} />
                      </IconButton>
                    </div>
                </TableColumn>
                <TableColumn>
                  <SelectField
                    helpText="Select a Variable type INT, FLOAT etc"
                    id={`variable-type-${i}`}
                    label="Type"
                    onChange={(value) => {
                      variableObj.type = value;
                      props.onTableRowChange(variableObj);
                    }}
                    menuItems={Object.keys(VariableTypes)}
                    value={variableObj.type}
                  />
                </TableColumn>
                {variableObj.type === VariableTypes.LIST ? (
                  <ListValuesSection
                    placeholder='Enter list values seperated by comma " , " '
                    variableObj={variableObj}
                    onTableRowChange={props.onTableRowChange}
                    onUploadFile={props.onUploadFile}
                    answerFormula={props.answerFormula}
                    key={`list-vals-section-${i}`}
                    helpText="Enter values seperated by comma eg: 1,2.5,3,4/5"
                  />
                ) : variableObj.type === VariableTypes.FRACTION ? (
                  <StaticValuesSection
                    placeholder='Enter fractions seperated by comma " , " '
                    variableObj={variableObj}
                    onTableRowChange={props.onTableRowChange}
                    key={`static-vals-section-${i}`}
                    helpText="Enter values seperated by Comma eg: 1/2,3/4"
                  />
                ) : variableObj.type === VariableTypes.SCIENTIFIC_NOTATION ? (
                  [
                    <MinMaxSection
                      variableObj={variableObj}
                      key={`min-max-section-1-${i}`}
                      minLabel="Min"
                      maxLabel="Max"
                      minHelpText="eg: 2.0, 5e-2"
                      maxHelpText="eg: 2.0, 5e-2"
                      onTableRowChange={props.onTableRowChange}
                    />,
                    <ScientificNotationSection
                      key={`sci-not-section-${i}`}
                      variableObj={variableObj}
                      digitsHelpText="Number of Digits before the Decimal eg: 3"
                      precisionHelpText="Number of Digits after Decimal point, the rest will be rounded"
                      onTableRowChange={props.onTableRowChange}
                    />,
                  ]
                ) : variableObj.type === VariableTypes.FLOAT ? (
                  <MinMaxSection
                    variableObj={variableObj}
                    key={`min-max-section-${i}`}
                    minLabel="Min Value"
                    maxLabel="Max Value"
                    minHelpText="eg: 2.0, 5e-2"
                    maxHelpText="eg: 2.0, 5e-2"
                    onTableRowChange={props.onTableRowChange}
                  />
                ) : (
                  <MinMaxSection
                    variableObj={variableObj}
                    key={`min-max-section-${i}`}
                    minLabel="Min Value"
                    maxLabel="Max Value"
                    minHelpText="eg: 2.0"
                    maxHelpText="eg: 2.0"
                    onTableRowChange={props.onTableRowChange}
                  />
                )}
                {variableObj.type === VariableTypes.FLOAT ? (
                  <TableColumn>
                    <TextField
                      id="text-sig-fig"
                      label="Significant Figures"
                      placeholder="Significant Figures"
                      type="number"
                      helpText="Significant Figures"
                      onChange={(value) => {
                        variableObj.sigFig = value;
                        props.onTableRowChange(variableObj);
                      }}
                      value={variableObj.sigFig || ""}
                    />
                  </TableColumn>
                ) : null}
                {variableObj.type !== VariableTypes.SCIENTIFIC_NOTATION &&
                variableObj.type !== VariableTypes.LIST ? (
                  <TableColumn>
                    <TextField
                      id="text-black-list"
                      label="Excluded List"
                      placeholder="Enter the excluded list values here, multiple values have to be comma seperated"
                      type="text"
                      helpText="Enter the excluded list values here, multiple values have to be comma seperated"
                      onChange={(value) => {
                        variableObj.rpBlackList = value;
                        props.onTableRowChange(variableObj);
                      }}
                      value={variableObj.rpBlackList || ""}
                    />
                  </TableColumn>
                ) : null}
                {variableObj.isStandaloneVariable ? 
                  <TableColumn style={{
                    width:'120px'
                  }}>
                    <IconButton aria-label="delete" onClick={() => {

                      let nameWithoutBrackets = variableObj.name.replace(/[\[\]]/g, '');
                      let evalName = `eval{${nameWithoutBrackets}}`

                      // Also check if it is used in answer text
                      if (props.answers && props.answers.length) {
                        for (let i = 0; i < props.answers.length; i++) {
                          let answer = props.answers[i];
                          if (answer && answer.answer_text && answer.answer_text.includes(evalName)) {
                            NotificationManager.error(`Variable "${nameWithoutBrackets}" is used in your answer text. Please remove it before deleting.`, "", 6000);
                            return;
                          }
                        }
                      }

                      // Check if variable name is used in the question text if yes dont delete
                      if (props.questionText.includes(evalName)) {
                        NotificationManager.error(`Variable "${nameWithoutBrackets}" is used in the question text. Please remove it before deleting.`, "", 6000);
                        return;
                      }

                      onVariableDeleteConfirm(variableObj)
                    }}>
                          <FaTrashAlt color="#bb0000" fontSize="inherit" /> 
                    </IconButton>
                  </TableColumn>
                : null}
              </TableRow>
            )})}
          </TableBody>
        </DataTable>

        <Button primary raised style={{marginTop:'1rem'}} onClick={() => {
          setVariableName("");
          setShowVariableNameDialog(true);
        }}>
          Add variable
        </Button>
      </CardText>
    </Card>
  );
};
const ScientificNotationSection = (props) => {
  let variableObj = props.variableObj;
  return [
    <TableColumn>
      <TextField
        label="Decimal Digits"
        onChange={(value) => {
          if (value.startsWith("-") || value.search("/") !== -1) {
            NotificationManager.error(
              "Error: Invalid format. Use only numbers >0. Don’t use negative numbers or fractions."
            );
          } else {
            variableObj.numberLength = value;
            props.onTableRowChange(variableObj);
          }
        }}
        helpText={props.digitsHelpText}
        value={variableObj.numberLength || ""}
        placeholder="Number Length"
        type="text"
      />
    </TableColumn>,
    <TableColumn>
      <TextField
        label="Precision"
        onChange={(value) => {
          if (value.search("-") !== -1 || value.search("/") !== -1) {
            NotificationManager.error(
              "Error: Invalid format. Use only numbers >0. Don’t use negative numbers or fractions."
            );
          } else {
            variableObj.precision = value;
            props.onTableRowChange(variableObj);
          }
        }}
        value={variableObj.precision || ""}
        placeholder="Precision"
        type="text"
        helpText={props.precisionHelpText}
      />
    </TableColumn>,
  ];
};
const StaticValuesSection = (props) => {
  let variableObj = props.variableObj;
  return (
    <TableColumn>
      <TextField
        id="static-values"
        placeholder={props.placeholder}
        type="text"
        label="Fraction List"
        value={variableObj.staticValues || ""}
        helpText={props.helpText}
        onChange={(value) => {
          variableObj.staticValues = value;
          props.onTableRowChange(variableObj);
        }}
      />
    </TableColumn>
  );
};

const ListValuesSection = (props) => {
  let variableObj = props.variableObj;
  const csvData = [
    [
      "In column 1 enter the Question [variable] values",
      "In columns 2 through n enter the n correct answer value(s)",
    ],
    ["Australia", "Melbourne", "Sydney", "Perth"],
    ["India", "New Delhi", "Mumbai", "Chennai"],
    ["USA", "Columbus", "New York", "San Francisco"],
  ];
  return (
    <TableColumn>
      <TextField
        id="list-values"
        placeholder={props.placeholder}
        type="text"
        label="List"
        value={variableObj.listValues || ""}
        helpText={props.helpText}
        onChange={(value) => {
          variableObj.listValues = value;
          props.onTableRowChange(variableObj);
        }}
      />
      {/*                 <FileInput onChange={ async (e) => {
                                const reader = new FileReader()
                                reader.onload = async (e) => { 
                                  const text = (e.target.result)
                                  console.log(text)
                                  alert(text)
                                };
                                reader.readAsText(e.target.files[0])
                              }
                } id="answersCSV" label="Upload CSV File" accept="text/csv"></FileInput> */}
      <CSVLink filename="List_Question_Answer_template.csv" data={csvData}>
        Download Template
      </CSVLink>{" "}
      <input
        id="fileUpload"
        accept=".csv"
        type="file"
        onClick={(e) => {
          e.target.value = "";
        }}
        onChange={async (e) => {
          e.preventDefault();
          const reader = new FileReader();
          reader.onload = async (e) => {
            const entries = e.target.result?.split('"').join("").split("\n");
            let listValueFromFile;
            let listValueMap = new Map();
            for (const entry of entries) {
              if (entry !== "" && entry !== undefined && entry.length !== 0) {
                let answers = "";
                let row = entry.split(",");
                if (entries.indexOf(entry) === 0) {
                  listValueFromFile = row[0];
                } else {
                  listValueFromFile = listValueFromFile + "," + row[0];
                }
                for (const questAns of row) {
                  if (row.indexOf(questAns) !== 0) {
                    if (row.length <= 2) {
                      answers = questAns;
                    } else if (row.length > 2) {
                      if (answers === undefined || answers === "") {
                        answers = questAns;
                      } else {
                        answers = answers + "," + questAns;
                      }
                    }
                  }
                }
                listValueMap.set(row[0], answers);
              }
            }
            variableObj.listValues = listValueFromFile;
            props.onTableRowChange(variableObj);
            props.onUploadFile(listValueMap);
          };
          reader.readAsText(e.target.files[0]);
        }}
      />
    </TableColumn>
  );
};

const MinMaxSection = (props) => {
  let variableObj = props.variableObj;
  return [
    <TableColumn key="min-text-field">
      <TextField
        label={props.minLabel}
        id="min-text-field"
        onChange={(value) => {
          variableObj.min = value;
          props.onTableRowChange(variableObj);
        }}
        value={variableObj.min}
        placeholder={props.minLabel}
        type="text"
        helpText={props.minHelpText}
      />
    </TableColumn>,
    <TableColumn key="max-text-field">
      <TextField
        label={props.maxLabel}
        id="max-text-field"
        value={variableObj.max}
        placeholder={props.maxLabel}
        type="text"
        onChange={(value) => {
          variableObj.max = value;
          props.onTableRowChange(variableObj);
        }}
        helpText={props.maxHelpText}
      />
    </TableColumn>,
  ];
};

export const QuestionHelp = function (props) {
  const [showOldHelp, setShowOldHelp] = useState(false);

  return (
    <div className="image-resize-warning RTWrapper">
      {/* New Help */}
      <p>
        <b>Help :</b> 
        <div style={{
          marginLeft:'12px',
        }}>
          <div style={{marginBottom:"4px"}}>
            1. To create one or more variables, use the Variables Table box below. The variables can be used in calculations of answers.
          </div>
          <div style={{marginBottom:"4px"}}>
            2. In the question box above, you can display the values of created variables by using \eval (e.g., \eval&#123;x&#125;, if the label in the Variables Table is "x")
          </div>
          <div style={{marginBottom:"4px"}}>
            3. Example: after creating variables "n_a" and "p" in the Variables Table: I have $n = &#92;eval&#123;n_a&#125;$ apples costing $p = &#92;eval&#123;p&#125;$ each, what is the total cost?
          </div>
          <div>
            4. You can also perform calculations using <a href="https://mathjs.org/docs/expressions/syntax.html" target="_blank">MathJS</a> expressions inside double curly brackets. Example: &#123;&#123; cos(&#92;eval&#123;x&#125;) ^ 2 &#125;&#125;
          </div>
        </div>
      </p>

      {/* Toggle inside box */}
      <p
        style={{
          cursor: "pointer",
          color: "#666",
          fontSize: "12px",
          marginTop: "8px",
          marginBottom: "4px",
        }}
        onClick={() => setShowOldHelp(!showOldHelp)}
      >
        {showOldHelp ? "Hide deprecated format ▲" : "Show deprecated format ▼"}
      </p>

      {/* Old Help (collapsible) */}
      {showOldHelp && (
        <div
          style={{
            borderTop: "1px dashed #ccc",
            paddingTop: "8px",
            opacity: 0.75,
          }}
        >
          <p><b>Deprecated :</b></p>

          <p>
            Enter variable names inside square bracket '[]', eg: I have [x]
            apples costing [y] each, what is the total cost?
          </p>

          <p>
            {`1.For Latex: use "$" to enter and exit latex mode: e.g., $\\alpha = \\frac{1}{137}$; `}
          </p>

          <p>
            2.For hyperlink: use HTML code: e.g.,
            &lt;a href="https://stemfluency.org" target="_blank"&gt;
            Go to STEM Fluency&lt;/a&gt;
          </p>
        </div>
      )}
    </div>
  );
};

export const StandardQuestionHelp = function (props) {
  return [
    <div className="image-resize-warning RTWrapper" key="help-text-1">
      <p>
      <b>Help :</b> 
      {/* 1.For Latex: use "$" to enter and exit latex mode: e.g., $\alpha = \frac{1}{137}$;  */}
      {`1.For Latex: use "$" to enter and exit latex mode: e.g., $\\alpha = \\frac{1}{137}$; `}
      </p>
      <p>
      2.For hyperlink: use HTML code: e.g.,  &lt;a href ="https://stemfluency.org" target="_blank"&gt;Go to STEM Fluency&lt;/a&gt;
      </p>
    </div>,
    <br key="help-text-br"></br>,
  ];
};

export const AnswerHelp = function (props) {
  return props.answerType && (props.answerType === 50 || props.answerType === 60) ?
        <p>
          <b>Help :</b>
          <div>
              1. Enter Formula with variables inside double curly brackets
              '&#123;&#123;&#125;&#125;' and variable names inside square brackets
              '[]', eg: &#123;&#123;[x]+[y]&#125;&#125;.
          </div>

          <div>
              2. You may also add text before or after: eg:
              &#123;&#123;[x]+[y]&#125;&#125; meters.
          </div>

          <div>
              3. For including variables in LaTeX expressions, a space is needed after
              the beginning \latex&#123; and before the ending \latex&#125;.
              Example: \cos&#123; &#123;&#123;[a]&#125;&#125; &#125;.
          </div>

          <div>
              4. For vector variables, \vec&#123;A&#125;_angle and \vec&#123;A&#125;_ang are treated
              as the same variable. Similarly, \vec&#123;A&#125;_mag and
              \vec&#123;A&#125;_magnitude are treated as the same variable.
          </div>
        </p>
        :
       RPAnswerHelp()
};


const RPAnswerHelp = function (props) {
  const [showOldHelp, setShowOldHelp] = useState(false);

  return (
    <div className="image-resize-warning RTWrapper">
      {/* New Help */}
      <p>
        <b>Help :</b> 
        <div style={{
          marginLeft:'12px',
        }}>
          <div>
            1. Enter Formula with variables inside double curly brackets &#123;&#123;&#125;&#125; and variable names with &#92;eval&#123;&#125;, eg: &#123;&#123; &#92;eval&#123;x&#125; + &#92;eval&#123;y&#125; &#125;&#125;.
          </div>
          <div>
            2. You may also add text before or after: eg: &#123;&#123; &#92;eval&#123;x&#125; + &#92;eval&#123;y&#125; &#125;&#125; meters.
          </div>
          <div>
            3. You can also perform calculations using <a href="https://mathjs.org/docs/expressions/syntax.html" target="_blank">MathJS</a> expressions inside double curly brackets. Example: &#123;&#123; cos(&#92;eval&#123;x&#125;) ^ 2 &#125;&#125;.
          </div>
          <div>
            4. For vector variables, <code>\vec&#123;A&#125;_angle</code> and <code>\vec&#123;A&#125;_ang</code> are treated as the same variable. Similarly, <code>\vec&#123;A&#125;_mag</code> and <code>\vec&#123;A&#125;_magnitude</code> are treated as the same variable.
          </div>
        </div>
      </p>

      {/* Toggle inside box */}
      <p
        style={{
          cursor: "pointer",
          color: "#666",
          fontSize: "12px",
          marginTop: "8px",
          marginBottom: "4px",
        }}
        onClick={() => setShowOldHelp(!showOldHelp)}
      >
        {showOldHelp ? "Hide deprecated format ▲" : "Show deprecated format ▼"}
      </p>

      {/* Old Help (collapsible) */}
      {showOldHelp && (
        <div
          style={{
            borderTop: "1px dashed #ccc",
            paddingTop: "8px",
            opacity: 0.75,
          }}
        >
          <p><b>Deprecated :</b></p>

          <p>
            <div>
              1. Enter Formula with variables inside double curly brackets
              '&#123;&#123;&#125;&#125;' and variable names inside square brackets
              '[]', eg: &#123;&#123;[x]+[y]&#125;&#125;.
          </div>

          <div>
              2. You may also add text before or after: eg:
              &#123;&#123;[x]+[y]&#125;&#125; meters.
          </div>

          <div>
              3. For including variables in LaTeX expressions, a space is needed after
              the beginning \latex&#123; and before the ending \latex&#125;.
              Example: \cos&#123; &#123;&#123;[a]&#125;&#125; &#125;.
          </div>

          <div>
              4. For vector variables, \vec&#123;A&#125;_angle and \vec&#123;A&#125;_ang are treated
              as the same variable. Similarly, \vec&#123;A&#125;_mag and
              \vec&#123;A&#125;_magnitude are treated as the same variable.
          </div>
        </p>

        </div>
      )}
    </div>
  );
};

export default VariablesTable;
